
  import { Component, Mixins } from 'vue-property-decorator';
  import UsersList from '@/mixins/usersList'

  @Component
  export default class Users extends Mixins(UsersList) {
  }
